// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    RAW: require('./image_formats/raw'),
    RLE: require('./image_formats/rle'),
    LayerRLE: require('./image_formats/layer_rle'),
    LayerRAW: require('./image_formats/layer_raw')
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/image_format.js
// module id = 24
// module chunks = 0